// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__13xUu","bigColWidth":"Table_bigColWidth__3VkeW","biggerColWidth":"Table_biggerColWidth__23wb6","row":"Table_row__1II5j","col":"Table_col__1m5QZ"};